import React from 'react';
import { Footer } from './components/nav/Footer';
import { Header } from './components/nav/Header';

import { RootServerSystemMetric } from './components/RootServerSystemMetricChart';
import {
  BrowserRouter as Router,
  Switch, Route, Redirect
} from "react-router-dom";
import { Home } from './components/Home';
import { RawData } from './components/RawData';
function App() {
  return (
    <Router>


      <div>
        <Header />
        <div className=" mt-2 min-vh-100">

          {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
          <Switch>
            <Redirect from="/raw-data/index.html" to="/raw" />
            <Redirect from="/rssac-metrics/raw" to="/raw" />
            <Redirect from="/metrics/index.html" to="/metrics" />
            <Redirect from="/rssac-metrics/metrics.html" to="/metrics" />
            <Redirect from="/metrics.html" to="/metrics" />

            <Route path="/metrics" component={RootServerSystemMetric} />
            <Route path="/raw/:id?" component={RawData} />
            <Route path="/raw" component={RawData} />

            <Route path="*" component={Home} />
          </Switch>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
